import * as ROUTES from 'Routes'
import { ROOT_URL } from 'gatsby-env-variables'
import { useState } from 'react'
import { navigate } from 'gatsby'
import classNames from 'classnames'
import ImgStoryblok from 'components/ImgStoryblok'
import Text from 'components/Text'
import Icon from 'rv-components/react/Icon'
import segment from 'utils/segment'
import GA from 'utils/GA'
import router from 'utils/router'
import useOriginTheme from 'hooks/useOriginTheme'
import useMediaQuery from 'hooks/useMediaQuery'
import { useContent } from 'modules/Content'
import './Header.styl'
import makeTrackings from 'utils/make'

const Header = ({ blok, location, overlap }) => {
  const [isOpen, setIsOpen] = useState(false)
  const { isRecoveryOrigin } = useOriginTheme()
  const { header_logo } = useContent('config')
  const originFlowImage = header_logo?.filter(
    (item) => item.component === 'Header'
  )?.[0]?.image

  const isNotMobile = useMediaQuery('notMobile')

  const buttonClickTrack = (ev) => {
    makeTrackings.elementClicked({
      location: ev.currentTarget.dataset.makeLocation,
      position: ev.currentTarget.dataset.makePosition,
      elementType: ev.currentTarget.dataset.makeElement,
      text: ev.currentTarget.textContent,
      htmlId: ev.currentTarget.dataset.unique,
      actionOutcome: ev.currentTarget.dataset.makeActionoutcome,
      outboundUrl: ev.currentTarget.dataset.makeOutboundurl,
    })
    segment.track('Button_Click', {
      id: ev.currentTarget.dataset.unique,
      text: ev.currentTarget.textContent,
    })
    GA.customEvent('buttonClick', {
      id: ev.currentTarget.dataset.unique,
      text: ev.currentTarget.textContent,
    })
  }

  const handleMenu = (ev) => {
    setIsOpen(!isOpen)

    makeTrackings.elementClicked({
      location: ev.currentTarget.dataset.makeLocation,
      position: ev.currentTarget.dataset.makePosition,
      elementType: ev.currentTarget.dataset.makeElement,
      text: ev.currentTarget.ariaLabel,
      htmlId: ev.currentTarget.dataset.unique,
      actionOutcome: ev.currentTarget.dataset.makeActionoutcome,
      outboundUrl: ev.currentTarget.dataset.makeOutboundurl,
    })
  }

  const renderOptions = () => {
    return (
      <div className="header-buttons" data-test="header-buttons">
        <a
          href="#BoletoExpress"
          onClick={buttonClickTrack}
          data-unique="d4d31dc1-7161-470a-99b2-0a0383f7e9a8"
          className="teste-teste"
          data-make-location="header"
          data-make-position="header-menu"
          data-make-actionoutcome="redirect"
          data-make-element="link"
        >
          <div className="outline">{blok.button_1}</div>
        </a>
        <a
          href="#DuvidasFrequentes"
          onClick={buttonClickTrack}
          data-unique="bd5f9539-7ab9-4d2c-addd-ebf5f2f5deb9"
          data-make-location="header"
          data-make-position="header-menu"
          data-make-actionoutcome="redirect"
          data-make-element="link"
        >
          <div className="outline">{blok.button_3}</div>
        </a>
        <a
          href="#"
          onClick={(e) => {
            buttonClickTrack(e)
            navigate(ROUTES.register.path, {
              state: {
                source_url: location.href,
                mp_uuid: router.getQueryString('mp_uuid'),
              },
            })
          }}
          role="button"
          data-unique="dead1e09-c6f8-47af-81b0-b83327aba12e"
          data-make-location="header"
          data-make-position="header-menu"
          data-make-actionoutcome="redirect"
          data-make-element="button"
          data-make-outboundurl={`${ROOT_URL}${ROUTES.register.path}`}
        >
          <div className="outline with-border">{blok.button_main}</div>
        </a>
      </div>
    )
  }

  const headerClassnames = classNames('header-container', {
    'blue-color': isOpen,
    overlap: overlap,
    'header-container__generalTheme': !isRecoveryOrigin,
  })

  return (
    <div className={headerClassnames}>
      <div className="header-content">
        <div className="logo-origin">
          <ImgStoryblok
            src={
              isRecoveryOrigin
                ? blok.url_logo.filename
                : originFlowImage?.filename
            }
            alt={`${isRecoveryOrigin ? 'Logo Recovery' : originFlowImage?.alt}`}
            width={isNotMobile ? 118 : 106}
            height={isNotMobile ? 30 : 27}
            data-test="header-logo-origin"
          />
        </div>
        {isRecoveryOrigin && (
          <div className="header-banner-itau" aria-label="Uma empresa Itaú">
            <Text p aria-hidden="true">
              Uma empresa
            </Text>
            <ImgStoryblok
              src="https://a.storyblok.com/f/119473/x/5d3952a243/itauicon_footer.svg"
              width={31}
              height={42}
              alt="Logo Itaú"
              aria-hidden="true"
            />
          </div>
        )}
        <button
          className="icon-menu"
          onClick={handleMenu}
          aria-haspopup="true"
          aria-controls="menu"
          aria-expanded={isOpen}
          aria-label={`${isOpen ? 'Fechar' : 'Abrir'} menu`}
          data-make-location="header"
          data-make-position="header-menu-mobile"
          data-make-actionoutcome="clique"
          data-make-element="button"
        >
          <Icon iconId={isOpen ? 'iconLPclose' : 'iconLPmenu'} />
        </button>
        {renderOptions()}
      </div>
      {isOpen && renderOptions()}
    </div>
  )
}

export default Header
